export default __webpack_public_path__ + "13e85cafdbe937c941a98fae9c492f90.png";